import {$, w} from './constants';

/**
 * Thumbnails:
 * - Para archivos locales (wp attachment) funciona
 * - Para URL externa fallará por CORS 
 */
export function renderPDFThumbnail() {
  const canvases = document.querySelectorAll('canvas[data-pdf-url]');

  canvases.forEach((canvas) => {
    const pdfUrl = canvas.getAttribute('data-pdf-url');
    if (!pdfUrl) return;

    if (typeof pdfjsLib === 'undefined') {
      console.warn('pdfjsLib not found. Skipping thumbnails.');
      return;
    }

    pdfjsLib.getDocument({
      url: pdfUrl,
      withCredentials: true
  }).promise
      .then((pdf) => pdf.getPage(1))
      .then((page) => {
          const viewport = page.getViewport({ scale: 1 });
          canvas.width = viewport.width;
          canvas.height = viewport.height;
  
          return page.render({
              canvasContext: canvas.getContext('2d'),
              viewport,
          }).promise;
      })
      .catch((err) => {
          console.warn('PDF thumbnail failed:', err);
      });
  });
}

export function viewerPDF() {
  $(document).on('click', '.btn_pop_pdf', function (e) {
    e.preventDefault();

    const post_id = parseInt($(this).data('post-document'), 10) || 0;
    const pdf_url = $(this).data('pdf-url') || '';
    const file_id = parseInt($(this).data('file-id'), 10) || 0;

    if (!post_id) return;

    fetch_viewer(file_id, post_id, pdf_url);
  });
}

const fetch_viewer = (file_id, post_id, pdf_url) => {
  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: cltvo_js_vars.ajax_url,
    data: {
      action: 'viewer_documents',
      post_id: post_id,
      file_id: file_id,
      pdf_url: pdf_url,
    },
    success: function (html) {
      $('#viewer_pop_up').empty().html(html).fadeIn(300);
      $(document)
        .off('click.viewer_close')
        .on('click.viewer_close', '#close_viewer_research', function () {
          $('#viewer_pop_up').fadeOut(300).empty();
        });
    },
    error: function (err) {
      console.log(err);
    },
  });
};